import { atom } from 'jotai';
import { createStore } from 'jotai/index';
import {
  DocumentClauseAPIModel,
  DocumentFieldAPIModel,
} from '~/api/def/endpoints/document';
import { FundDocument } from '~/api/def/endpoints/fundEndpoint';
import {
  DocumentFieldDefinition,
  DocumentPDFField,
  PDFClause,
} from '~/lib/pdfViewer/types';

export const clausesAtom = atom<DocumentClauseAPIModel[]>([]);
export const documentFieldsAtom = atom<DocumentFieldAPIModel[]>([]);
export const documentMetaAtom = atom<FundDocument | null>(null);
export const fieldTypesAtom = atom<DocumentFieldDefinition[]>([]);
export const pdfClausesAtom = atom<PDFClause[]>([]);
export const pdfFieldsAtom = atom<DocumentPDFField[]>([]);
export const globalSearchPdfFieldAtom = atom<DocumentPDFField | null>(null);
export const pdfFieldsMergedAtom = atom<DocumentPDFField[]>((get) => {
  const list = [...get(pdfFieldsAtom)];
  const search = get(globalSearchPdfFieldAtom);
  if (search) {
    list.unshift(search);
  }
  return list;
});

export const documentUrlAtom = atom<string | undefined>();
export const loadingClausesAtom = atom<boolean>(false);
export const loadingFieldsAtom = atom<boolean>(false);
export const loadingDocumentMetaAtom = atom<boolean>(false);
export const loadingDocumentUrlAtom = atom<boolean>(false);

export const highlightedFieldAtom = atom<string | null>(null);
export const DocumentOverviewStore = createStore();
